<div class="container-fluid" style="height: 100vh;">
    <div class="d-flex h-100 justify-content-center not-found">
        <div class="align-self-center text-center">
            <span class="not-found-title"> 404 </span>
            <br/>
            <span class="not-found-title2"> Page Not Found </span>
            <br/>
            <button type="button" class="btn btn-primary mt-3 rounded-pill px-5" (click)="goHome()"> Back To Home </button>
        </div>
    </div>
</div>
